import sendLocalRequest from "./sendLocalRequest";
export const renewToken = (token, refreshToken) => {
    const data = {
        "token": token,
        "refresh_token": refreshToken
    }
    return sendLocalRequest("renew_token", "POST", null,  data);
}
